import React, { Component } from 'react';
import $ from "jquery";
import axios from 'axios';
class EducationalQualificationsAndBarDetails extends Component {
  constructor() {
    super();
    this.state = {
      submit_button:<button className="btn btn-primary w-100 py-3" type="button" onClick={this.add_emp_basic_details.bind(this)}>Update</button>,
      downloads_div:'',
    };
  }


  componentDidMount(){
    this.get_emp_basic_details();
  }
  get_emp_basic_details(){
      var cutThis           = this;
      var emp_id            = cutThis.props.id;
      var web_token         = window.isNullAndUndef($('#web_token').val());
      var body = new FormData();
      body.append('emp_id',emp_id);
      body.append('web_token',web_token);
      body.append('form_type','employee_educational_qualifications_and_bar_details');
      body.append('function','get_emp_basic_details');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/admin_employee_management_url.php";
      }else{
        url = "/php/admin_employee_management_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           data: body
       })
       .then(function (res) {
          var data = res.data;
          if(data['error']==1){
            var new_data = data['data'];
            cutThis.update_info(new_data);
            cutThis.downloads_files(data);
          }

       })
       .catch(function (error) {
           console.log(error);
       });
  }

  downloads_files(data){
    var emp_id  = data['emp_id'];
    var file_id = data['id'];
    var downloads_div = [];
    downloads_div.push(<div className="col-md-3"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'enrolment_certificate')}><i class="fas fa-file-download"></i> Enrolment Certificate</a></div>);
    downloads_div.push(<div className="col-md-3"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'certificate_practice')}><i class="fas fa-file-download"></i> Certificate of Practice</a></div>);
    downloads_div.push(<div className="col-md-3"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'disciplinary_actions_suspensions')}><i class="fas fa-file-download"></i> Any Disciplinary Actions or Suspensions</a></div>);
    downloads_div.push(<div className="col-md-3"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'proof_of_active_practice')}><i class="fas fa-file-download"></i> Proof of Active Practice</a></div>);
    this.setState({downloads_div});
  }

  check_download_file(file_id,emp_id,file_name){
    var web_token         = window.isNullAndUndef($('#web_token').val());
    var form_type         = 'employee_educational_qualifications_and_bar_details';
    var url = '';
    if(window.location.host ==="localhost:3000"){
      url = "http://localhost/bylawsindia/php/admin_download_employee_files_url.php";
    }else{
      url = "/php/admin_download_employee_files_url.php";
    }
    var new_str = '?emp_id='+emp_id+"&file_id="+file_id+'&file_name='+file_name+"&function=check_download_emp_file&form_type="+form_type+"&web_token="+web_token;
    window.open(url+new_str, '_blank');
  }

  update_info(data){
    $('#highest_qualification').val(data['highest_qualification']);
    $('#institution_name_passing_year').val(data['institution_name_passing_year']);
    $('#bar_council_enrolment_no').val(data['bar_council_enrolment_no']);
    $('#state_bar_council_name_registration_details').val(data['state_bar_council_name_registration_details']);

    $('#old_enrolment_certificate').val(data['enrolment_certificate_new_name']);
    $('#old_certificate_practice').val(data['certificate_practice_new_name']);
    $('#old_disciplinary_actions_suspensions').val(data['disciplinary_actions_suspensions_new_name']);
    $('#old_proof_of_active_practice').val(data['proof_of_active_practice_new_name']);
  }

  add_emp_basic_details(){
    var file_main_ext       = ['pdf','PDF'];
    var cutThis             = this;
    var emp_id              = cutThis.props.id;
    var web_token           = window.isNullAndUndef($('#web_token').val());

    var highest_qualification                           = window.isNullAndUndef($('#highest_qualification').val());
    var institution_name_passing_year                   = window.isNullAndUndef($('#institution_name_passing_year').val());
    var bar_council_enrolment_no                        = window.isNullAndUndef($('#bar_council_enrolment_no').val());
      var state_bar_council_name_registration_details   = window.isNullAndUndef($('#state_bar_council_name_registration_details').val());

    var enrolment_certificate_temp                      = window.isNullAndUndef($('#enrolment_certificate').val());
    var org_enrolment_certificate                       = $("#enrolment_certificate").prop("files")[0];
    var enrolment_certificate_name                      = $('#enrolment_certificate').val().split('\\').pop();

    var certificate_practice_temp                       = window.isNullAndUndef($('#certificate_practice').val());
    var org_certificate_practice                        = $("#certificate_practice").prop("files")[0];
    var certificate_practice_name                       = $('#certificate_practice').val().split('\\').pop();


    var disciplinary_actions_suspensions_temp           = window.isNullAndUndef($('#disciplinary_actions_suspensions').val());
    var org_disciplinary_actions_suspensions            = $("#disciplinary_actions_suspensions").prop("files")[0];
    var disciplinary_actions_suspensions_name           = $('#disciplinary_actions_suspensions').val().split('\\').pop();

    var proof_of_active_practice_temp                   = window.isNullAndUndef($('#proof_of_active_practice').val());
    var org_proof_of_active_practice                    = $("#proof_of_active_practice").prop("files")[0];
    var proof_of_active_practice_name                   = $('#proof_of_active_practice').val().split('\\').pop();

//-----------------
    var enrolment_certificate_ext               = -1;
    var certificate_practice_ext                = -1;
    var disciplinary_actions_suspensions_ext    = -1;
    var proof_of_active_practice_ext            = -1;
    if(enrolment_certificate_temp && certificate_practice_temp && disciplinary_actions_suspensions_temp && proof_of_active_practice_temp){
      enrolment_certificate_ext               = enrolment_certificate_temp.split('.').pop();
      certificate_practice_ext                = certificate_practice_temp.split('.').pop();
      disciplinary_actions_suspensions_ext    = disciplinary_actions_suspensions_temp.split('.').pop();
      proof_of_active_practice_ext            = proof_of_active_practice_temp.split('.').pop();
    }
//--------------------------

    var submit_button     = <button className="btn btn-primary w-100 py-3" type="button">Update...</button>;
    cutThis.setState({submit_button});
    $('label').removeClass('color_red');
    if(highest_qualification && institution_name_passing_year && bar_council_enrolment_no && state_bar_council_name_registration_details && file_main_ext.indexOf(enrolment_certificate_ext) >= 0 && file_main_ext.indexOf(certificate_practice_ext) >= 0 && file_main_ext.indexOf(disciplinary_actions_suspensions_ext) >= 0 && file_main_ext.indexOf(proof_of_active_practice_ext) >= 0){
      var old_enrolment_certificate                                 = $('#old_enrolment_certificate').val();
      var old_certificate_practice                                  = $('#old_certificate_practice').val();
      var old_disciplinary_actions_suspensions                      = $('#old_disciplinary_actions_suspensions').val();
      var old_proof_of_active_practice                              = $('#old_proof_of_active_practice').val();


      var all_data                                                  = {};
      all_data['highest_qualification']                             = window.return_false_null(highest_qualification);
      all_data['institution_name_passing_year']                     = window.return_false_null(institution_name_passing_year);
      all_data['bar_council_enrolment_no']                          = window.return_false_null(bar_council_enrolment_no);
      all_data['state_bar_council_name_registration_details']       = window.return_false_null(state_bar_council_name_registration_details);

      all_data['enrolment_certificate_name']                        = window.return_false_null(enrolment_certificate_name);
      all_data['certificate_practice']                              = window.return_false_null(certificate_practice_name);
      all_data['disciplinary_actions_suspensions']                  = window.return_false_null(disciplinary_actions_suspensions_name);
      all_data['proof_of_active_practice']                          = window.return_false_null(proof_of_active_practice_name);


      var body = new FormData();
      body.append('emp_id',emp_id);

      body.append('enrolment_certificate',org_enrolment_certificate);
      body.append('old_enrolment_certificate',old_enrolment_certificate);

      body.append('certificate_practice',org_certificate_practice);
      body.append('old_certificate_practice',old_certificate_practice);

      body.append('disciplinary_actions_suspensions',org_disciplinary_actions_suspensions);
      body.append('old_disciplinary_actions_suspensions',old_disciplinary_actions_suspensions);

      body.append('proof_of_active_practice',org_proof_of_active_practice);
      body.append('old_proof_of_active_practice',old_proof_of_active_practice);

      body.append('emp_date',JSON.stringify(all_data));
      body.append('web_token',web_token);
      body.append('form_type','employee_educational_qualifications_and_bar_details');
      body.append('function','add_emp_basic_details');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/admin_employee_management_url.php";
      }else{
        url = "/php/admin_employee_management_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           async: false,
           data: body,
           enctype: 'multipart/form-data',
           processData: false,
           contentType: false,
           cache: false,
       })
       .then(function (res) {
          var data = res.data;
          $('#error_msg').text(data['msg']);
          submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
          cutThis.setState({submit_button});
          cutThis.get_emp_basic_details();
       })
       .catch(function (error) {
           console.log(error);
       });
    }else {
      window.change_lable_color('highest_qualification','institution_name_passing_year','bar_council_enrolment_no','state_bar_council_name_registration_details','enrolment_certificate','certificate_practice','disciplinary_actions_suspensions','proof_of_active_practice');
      submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
      cutThis.setState({submit_button});
    }

  }


  render() {
    return (
        <>
        	<div className="mt-4 mb-4">
                <h3 className="wow fadeInUp" data-wow-delay="0.1s">{this.props.page_title}</h3>
                <div className="row g-4">


                <div className="col-md-12">
                    <div className="wow fadeInUp" data-wow-delay="0.5s">
                        <form action="" method="post">
                            <div className="row g-3">

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="highest_qualification" placeholder="Highest Qualification"/>
                                        <label for="name">Highest Qualification</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="institution_name_passing_year" placeholder="Institution Name & Year of Passing"/>
                                        <label for="name">Institution Name & Year of Passing</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="bar_council_enrolment_no" placeholder="Bar Council Enrolment Number"/>
                                        <label for="name">Bar Council Enrolment Number</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="state_bar_council_name_registration_details" placeholder="Bar Council Enrolment Number"/>
                                        <label for="name">State Bar Council Name & Registration Details</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_enrolment_certificate" placeholder=""/>
                                        <input type="file" className="form-control" id="enrolment_certificate" placeholder="Enrolment Certificate (Scanned Copy)"/>
                                        <label for="name">Enrolment Certificate (Scanned Copy)</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_certificate_practice" placeholder=""/>
                                        <input type="file" className="form-control" id="certificate_practice" placeholder="Certificate of Practice"/>
                                        <label for="name">Certificate of Practice</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_disciplinary_actions_suspensions" placeholder=""/>
                                        <input type="file" className="form-control" id="disciplinary_actions_suspensions" placeholder="Any Disciplinary Actions or Suspensions"/>
                                        <label for="name">Any Disciplinary Actions or Suspensions</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_proof_of_active_practice" placeholder=""/>
                                        <input type="file" className="form-control" id="proof_of_active_practice" placeholder="Proof of Active Practice"/>
                                        <label for="name">Proof of Active Practice</label>
                                    </div>
                                </div>


                              <div className="col-md-12">
                                  <div className="col-md-4">
                                    <p id="error_msg"></p>
                                  </div>
                                  <div className="col-md-4">
                                    <p># Form upload, only allow PDF</p>
                                  </div>
                                  <div className="col-md-4 p-0 float_r">
                                      {this.state.submit_button}
                                  </div>
                              </div>
                              {this.state.downloads_div}

                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </div>

        </>
    );
  }
}

export default EducationalQualificationsAndBarDetails;
